import React, { memo, useCallback } from "react";
import { NodeProps, useReactFlow } from "reactflow";
import { NodeType } from "../../../models/nodeType";
import BaseNode from "../../../features/reactflow/nodes/base/BaseNode";
import { useForm } from "react-hook-form";
import { Box } from "@chakra-ui/react";
import SelectRoom from "../../base/SelectRoom";

interface FormData {
  roomName: string;
}

const RoomNode: React.FC<NodeProps<NodeType>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData = {} },
  } = props;

  const formData = nodeData as FormData | undefined;
  const roomName = formData?.roomName;

  const { getValues, setValue, handleSubmit } = useForm<FormData>({
    defaultValues: {
      roomName,
    },
    mode: "onBlur",
  });

  const reactFlow = useReactFlow();

  const handleUpdate = useCallback(
    ({ roomName }: FormData) => {
      reactFlow.setNodes((nodes) => {
        const node = nodes.find(({ id }) => id === nodeId);

        if (node == null) {
          return nodes;
        }

        const nodeDataCloned = structuredClone(node.data) as NodeType;

        const nodeData = (nodeDataCloned.nodeData as FormData) ?? {};
        nodeData.roomName = roomName;

        node.data = {
          ...nodeDataCloned,
          nodeData,
        };

        return nodes;
      });
    },
    [reactFlow]
  );

  return (
    <BaseNode {...props}>
      <Box p={2}>
        <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
          <SelectRoom value={getValues("roomName")} setValue={(value) => setValue("roomName", value)} color={color} />
        </form>
      </Box>
    </BaseNode>
  );
};

export default memo(RoomNode);
